module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroid.14e8ba9a.svg";